import { Source, SourceComplete } from "../enums/Source.enum";

export const isSourceFordPass = (source: string): boolean => source === Source.fordpass || SourceComplete.fordpass === source;

export const clearStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
};
// TODO: Implement getLangByCountry function
export const getLangByCountry = (country: string) => {
  switch (country) {
    case 'BRA':
      return 'pt-BR';
    case 'ARG':
      return 'es-AR';
    case 'CHL':
      return 'es-CL';
    case 'PER':
      return 'es-PE';
    case 'COL':
      return 'es-CO';
    case 'ECU':
      return 'es-EC';
    case 'VEN':
      return 'es-VE';
    default:
      return 'en-US';
  }
};
